// extracted by mini-css-extract-plugin
export var marginNegative = "_71-5 _71-3 _71-1";
export var marginPositive = "_71-4 _71-3 _71-1";
export var modalContent = "_71-6";
export var samplesTable = "_71-8";
export var samplesTableContainer = "_71-7";
export var statBox = "_71-a";
export var tableCell = "_71-1";
export var tableCellCenter = "_71-2 _71-1";
export var tableCellRight = "_71-3 _71-1";
export var tableHeader = "_71-0";
export var trackingNumber = "_71-9";